import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

import chatify from "../../Assets/Projects/chatify.png";

function Projects() {
  return (
    <Container fluid className="project-section" style={{ height: "60rem" }}>
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="E-preneur"
              description="Your guide to upskilling your entrepreneurship qualifications."
              ghLink="https://docs.google.com/presentation/d/1FdjU_OnAPLLGX-YMX8_72LG6KoTMqpiY9xVt65CrqEw/edit#slide=id.p"
              demoLink="https://youtu.be/iV5GvuOZ9o4"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
